<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Trofeos" />
    <Prizes />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Prizes from "@/components/Pages/Admin/Prizes/index.vue";

export default defineComponent({
  name: "PrizesPage",
  components: {
    PageTitle,
    Prizes,
  },
});
</script>